import { ArrowClockwiseIcon as PhArrowClockwise } from '@phosphor-icons/react/ArrowClockwise';
import { ArrowCounterClockwiseIcon as PhArrowCounterClockwise } from '@phosphor-icons/react/ArrowCounterClockwise';
import { ArrowDownIcon as PhArrowDown } from '@phosphor-icons/react/ArrowDown';
import { ArrowLeftIcon as PhArrowLeft } from '@phosphor-icons/react/ArrowLeft';
import { ArrowRightIcon as PhArrowRight } from '@phosphor-icons/react/ArrowRight';
import { ArrowsClockwiseIcon as PhArrowsClockwise } from '@phosphor-icons/react/ArrowsClockwise';
import { ArrowSquareOutIcon as PhArrowSquareOut } from '@phosphor-icons/react/ArrowSquareOut';
import { ArrowUpIcon as PhArrowUp } from '@phosphor-icons/react/ArrowUp';
import { ArticleIcon as PhArticle } from '@phosphor-icons/react/Article';
import { CalendarIcon as PhCalendar } from '@phosphor-icons/react/Calendar';
import { CalendarDotsIcon as PhCalendarDots } from '@phosphor-icons/react/CalendarDots';
import { CaretDoubleLeftIcon as PhCaretDoubleLeft } from '@phosphor-icons/react/CaretDoubleLeft';
import { CaretDownIcon as PhCaretDown } from '@phosphor-icons/react/CaretDown';
import { CaretLeftIcon as PhCaretLeft } from '@phosphor-icons/react/CaretLeft';
import { CaretLineLeftIcon as PhCaretLineLeft } from '@phosphor-icons/react/CaretLineLeft';
import { CaretLineRightIcon as PhCaretLineRight } from '@phosphor-icons/react/CaretLineRight';
import { CaretRightIcon as PhCaretRight } from '@phosphor-icons/react/CaretRight';
import { CaretUpIcon as PhCaretUp } from '@phosphor-icons/react/CaretUp';
import { CellTowerIcon as PhCellTower } from '@phosphor-icons/react/CellTower';
import { ChartBarIcon as PhChartBar } from '@phosphor-icons/react/ChartBar';
import { ChartLineUpIcon as PhChartLineUp } from '@phosphor-icons/react/ChartLineUp';
import { ChatCircleIcon as PhChatCircle } from '@phosphor-icons/react/ChatCircle';
import { ChatsIcon as PhChats } from '@phosphor-icons/react/Chats';
import { ChatsCircleIcon as PhChatsCircle } from '@phosphor-icons/react/ChatsCircle';
import { CheckIcon as PhCheck } from '@phosphor-icons/react/Check';
import { CheckCircleIcon as PhCheckCircle } from '@phosphor-icons/react/CheckCircle';
import { CheckSquareIcon as PhCheckSquare } from '@phosphor-icons/react/CheckSquare';
import { ClipboardTextIcon as PhClipboardText } from '@phosphor-icons/react/ClipboardText';
import { ClosedCaptioningIcon as PhClosedCaptioning } from '@phosphor-icons/react/ClosedCaptioning';
import { CloudSlashIcon as PhCloudSlash } from '@phosphor-icons/react/CloudSlash';
import { ConfettiIcon as PhConfetti } from '@phosphor-icons/react/Confetti';
import { CopyIcon as PhCopy } from '@phosphor-icons/react/Copy';
import { CornersOutIcon as PhCornersOut } from '@phosphor-icons/react/CornersOut';
import { DevicesIcon as PhDevices } from '@phosphor-icons/react/Devices';
import { DotsSixVerticalIcon as PhDotsSixVertical } from '@phosphor-icons/react/DotsSixVertical';
import { DotsThreeIcon as PhDotsThree } from '@phosphor-icons/react/DotsThree';
import { DotsThreeVerticalIcon as PhDotsThreeVertical } from '@phosphor-icons/react/DotsThreeVertical';
import { DownloadSimpleIcon as PhDownloadSimple } from '@phosphor-icons/react/DownloadSimple';
import { EarIcon as PhEar } from '@phosphor-icons/react/Ear';
import { EnvelopeIcon as PhEnvelope } from '@phosphor-icons/react/Envelope';
import { ExclamationMarkIcon as PhExclamationMark } from '@phosphor-icons/react/ExclamationMark';
import { EyeIcon as PhEye } from '@phosphor-icons/react/Eye';
import { EyeSlashIcon as PhEyeSlash } from '@phosphor-icons/react/EyeSlash';
import { FileTextIcon as PhFileText } from '@phosphor-icons/react/FileText';
import { FlaskIcon as PhFlask } from '@phosphor-icons/react/Flask';
import { FunnelSimpleIcon as PhFunnelSimple } from '@phosphor-icons/react/FunnelSimple';
import { GearIcon as PhGear } from '@phosphor-icons/react/Gear';
import { GitCommitIcon as PhGitCommit } from '@phosphor-icons/react/GitCommit';
import { GlobeIcon as PhGlobe } from '@phosphor-icons/react/Globe';
import { HandIcon as PhHand } from '@phosphor-icons/react/Hand';
import { HandPalmIcon as PhHandPalm } from '@phosphor-icons/react/HandPalm';
import { HashIcon as PhHash } from '@phosphor-icons/react/Hash';
import { HeadphonesIcon as PhHeadphones } from '@phosphor-icons/react/Headphones';
import { HourglassSimpleIcon as PhHourglassSimple } from '@phosphor-icons/react/HourglassSimple';
import { HouseIcon as PhHouse } from '@phosphor-icons/react/House';
import { ImageIcon as PhImage } from '@phosphor-icons/react/Image';
import { ImageBrokenIcon as PhImageBroken } from '@phosphor-icons/react/ImageBroken';
import { InfoIcon as PhInfo } from '@phosphor-icons/react/Info';
import { KeyboardIcon as PhKeyboard } from '@phosphor-icons/react/Keyboard';
import { LifebuoyIcon as PhLifebuoy } from '@phosphor-icons/react/Lifebuoy';
import { LinkIcon as PhLink } from '@phosphor-icons/react/Link';
import { ListIcon as PhList } from '@phosphor-icons/react/List';
import { ListBulletsIcon as PhListBullets } from '@phosphor-icons/react/ListBullets';
import { ListNumbersIcon as PhListNumbers } from '@phosphor-icons/react/ListNumbers';
import { LockIcon as PhLock } from '@phosphor-icons/react/Lock';
import { MagnifyingGlassIcon as PhMagnifyingGlass } from '@phosphor-icons/react/MagnifyingGlass';
import { MicrophoneIcon as PhMicrophone } from '@phosphor-icons/react/Microphone';
import { MicrophoneSlashIcon as PhMicrophoneSlash } from '@phosphor-icons/react/MicrophoneSlash';
import { MinusIcon as PhMinus } from '@phosphor-icons/react/Minus';
import { MinusSquareIcon as PhMinusSquare } from '@phosphor-icons/react/MinusSquare';
import { MonitorArrowUpIcon as PhMonitorArrowUp } from '@phosphor-icons/react/MonitorArrowUp';
import { PaperPlaneTiltIcon as PhPaperPlaneTilt } from '@phosphor-icons/react/PaperPlaneTilt';
import { PauseIcon as PhPause } from '@phosphor-icons/react/Pause';
import { PencilSimpleIcon as PhPencilSimple } from '@phosphor-icons/react/PencilSimple';
import { PhoneIcon as PhPhone } from '@phosphor-icons/react/Phone';
import { PlayIcon as PhPlay } from '@phosphor-icons/react/Play';
import { PlayCircleIcon as PhPlayCircle } from '@phosphor-icons/react/PlayCircle';
import { PlusIcon as PhPlus } from '@phosphor-icons/react/Plus';
import { PowerIcon as PhPower } from '@phosphor-icons/react/Power';
import { ProhibitIcon as PhProhibit } from '@phosphor-icons/react/Prohibit';
import { PushPinIcon as PhPushPin } from '@phosphor-icons/react/PushPin';
import { QuestionIcon as PhQuestion } from '@phosphor-icons/react/Question';
import { RadioButtonIcon as PhRadioButton } from '@phosphor-icons/react/RadioButton';
import { RocketIcon as PhRocket } from '@phosphor-icons/react/Rocket';
import { SealCheckIcon as PhSealCheck } from '@phosphor-icons/react/SealCheck';
import { ShareNetworkIcon as PhShareNetwork } from '@phosphor-icons/react/ShareNetwork';
import { ShieldWarningIcon as PhShieldWarning } from '@phosphor-icons/react/ShieldWarning';
import { SignInIcon as PhSignIn } from '@phosphor-icons/react/SignIn';
import { SignOutIcon as PhSignOut } from '@phosphor-icons/react/SignOut';
import { SmileyIcon as PhSmiley } from '@phosphor-icons/react/Smiley';
import { SparkleIcon as PhSparkle } from '@phosphor-icons/react/Sparkle';
import { SpeakerHighIcon as PhSpeakerHigh } from '@phosphor-icons/react/SpeakerHigh';
import { SpeakerLowIcon as PhSpeakerLow } from '@phosphor-icons/react/SpeakerLow';
import { SpeakerSlashIcon as PhSpeakerSlash } from '@phosphor-icons/react/SpeakerSlash';
import { SpeedometerIcon as PhSpeedometer } from '@phosphor-icons/react/Speedometer';
import { SquareIcon as PhSquare } from '@phosphor-icons/react/Square';
import { StarIcon as PhStar } from '@phosphor-icons/react/Star';
import { StopIcon as PhStop } from '@phosphor-icons/react/Stop';
import { TagIcon as PhTag } from '@phosphor-icons/react/Tag';
import { TextBIcon as PhTextB } from '@phosphor-icons/react/TextB';
import { TextItalicIcon as PhTextItalic } from '@phosphor-icons/react/TextItalic';
import { TextUnderlineIcon as PhTextUnderline } from '@phosphor-icons/react/TextUnderline';
import { ThumbsDownIcon as PhThumbsDown } from '@phosphor-icons/react/ThumbsDown';
import { ThumbsUpIcon as PhThumbsUp } from '@phosphor-icons/react/ThumbsUp';
import { TimerIcon as PhTimer } from '@phosphor-icons/react/Timer';
import { TrashIcon as PhTrash } from '@phosphor-icons/react/Trash';
import { UploadSimpleIcon as PhUploadSimple } from '@phosphor-icons/react/UploadSimple';
import { UserIcon as PhUser } from '@phosphor-icons/react/User';
import { UserCircleIcon as PhUserCircle } from '@phosphor-icons/react/UserCircle';
import { UserGearIcon as PhUserGear } from '@phosphor-icons/react/UserGear';
import { UserPlusIcon as PhUserPlus } from '@phosphor-icons/react/UserPlus';
import { UsersIcon as PhUsers } from '@phosphor-icons/react/Users';
import { UserSoundIcon as PhUserSound } from '@phosphor-icons/react/UserSound';
import { UsersThreeIcon as PhUsersThree } from '@phosphor-icons/react/UsersThree';
import { VideoCameraIcon as PhVideoCamera } from '@phosphor-icons/react/VideoCamera';
import { VideoCameraSlashIcon as PhVideoCameraSlash } from '@phosphor-icons/react/VideoCameraSlash';
import { WarningIcon as PhWarning } from '@phosphor-icons/react/Warning';
import { WarningCircleIcon as PhWarningCircle } from '@phosphor-icons/react/WarningCircle';
import { WaveformIcon as PhWaveform } from '@phosphor-icons/react/Waveform';
import { WifiHighIcon as PhWifiHigh } from '@phosphor-icons/react/WifiHigh';
import { WifiLowIcon as PhWifiLow } from '@phosphor-icons/react/WifiLow';
import { WifiMediumIcon as PhWifiMedium } from '@phosphor-icons/react/WifiMedium';
import { XIcon as PhX } from '@phosphor-icons/react/X';

import type { Icon as PhosphorIcon, IconWeight } from '@phosphor-icons/react';
import type { PhosphorSwap } from 'common/theme/utils';

/**
 * Which glyph in `icons/index.ts` has a Phosphor counterpart, and for the ones that do not, why
 * (HNS-262). Read by the barrel to build each icon, and by `IconGallery.stories.tsx` to render the
 * open questions for design.
 *
 * ONE table rather than a mapping plus a Markdown doc, because the two would drift the first time a
 * glyph moved. The story is generated from the same object the app renders, so "what did we not
 * swap, and why" is always the current answer.
 *
 * Deep imports (`@phosphor-icons/react/X`) rather than the package root, and not for style: the root
 * barrel statically imports all 1512 CSR modules AND all 1512 SSR ones. Production tree-shakes that,
 * but Vite would pre-bundle ~4500 modules into one optimized dep in dev and under the Storybook test
 * runner — and mid-run re-optimization is exactly what `vitest.storybook.config.ts` was built to
 * avoid. The bare `./*` wildcard in the package's `exports` map resolves both runtime and types.
 *
 * Every import is aliased `Ph*` because Phosphor 2.1's own export names are ALSO `*Icon`-suffixed
 * (the bare `Check`/`Copy` forms are deprecated), so `CheckIcon` would collide with ours.
 *
 * TODO(HNS-264): retire with the flag. The swaps become plain Phosphor imports in the barrel, and the
 * `ask`/`none` rows become whatever design decides.
 */
export type IconSwapStatus =
  /** A genuine 1:1 match. Ships behind the flag. */
  | 'swap'
  /** A near miss with a named candidate. Keeps the legacy glyph; goes to design. */
  | 'ask'
  /** Nothing in Phosphor expresses this. Keeps the legacy glyph, permanently or otherwise. */
  | 'none';

export type IconSwapEntry = {
  status: IconSwapStatus;
  /** Non-null ONLY for `swap`. See the constructors below — this is not settable by hand. */
  swap: PhosphorSwap;
  /** For `ask`: the Phosphor glyph that was considered, so design can see it side by side. */
  candidate?: string;
  /** For `ask` and `none`: why it did not move. This is the agenda for the designer sync. */
  reason?: string;
};

/**
 * The three constructors exist so "refuse rather than approximate" is enforced structurally rather
 * than by review: an `ask` or a `none` CANNOT carry a swap, because neither constructor takes one.
 * Naming a candidate and shipping it are separate acts, and only one of them is reversible cheaply.
 */
const swapTo = (icon: PhosphorIcon, weight?: IconWeight): IconSwapEntry => ({
  status: 'swap',
  swap: weight ? { icon, weight } : { icon },
});

const ask = (candidate: string, reason: string): IconSwapEntry => ({ status: 'ask', swap: null, candidate, reason });

const none = (reason: string): IconSwapEntry => ({ status: 'none', swap: null, reason });

/**
 * Two glyphs collapsing onto one Phosphor glyph is only a problem when they are meaningfully
 * different today. Where the pair is already near-identical — `Pause`/`PauseOutlined`,
 * `Settings`/`SettingsOutlined`, `Logout`/`LogoutOutlined`/`ExitToApp` — both swap and the
 * duplication becomes an HNS-264 de-dup rather than a design question. Where they are not, both stay
 * put; `ScreenShare`/`PresentToAll` is the clearest case.
 */
const COLLAPSES_ONTO = (other: string, glyph: string) =>
  `Would collapse onto ${other}, which is a distinct glyph today; Phosphor has only ${glyph}.`;

/**
 * ── Weight: outlined, with four exceptions ─────────────────────────────────────────────────────
 *
 * Every swap below is at Phosphor's default `regular` weight. Design feedback on HNS-362 — "keep the
 * icons outlined" — and it is the general form of a rule the refresh had already been applying one
 * call site at a time: `RaiseHandButton` reads *"the subtle blue fill is what says 'on', so the glyph
 * does not also change"*, and `ReactionPickerButton` does the same. Stating it in the table means new
 * rows inherit it instead of each control re-deciding.
 *
 * `weight: 'fill'` therefore survives only where solid is the GLYPH rather than a state: `PlayArrow`
 * and `Stop` (an outlined triangle or square is a different symbol, not a lighter one) and
 * `CheckBox`/`IndeterminateCheckBox` (Material's *checked* marks — outlined, a checked box would read
 * as unchecked).
 *
 * Two consequences, both intended, both worth knowing before anyone "fixes" them:
 *
 *   - a `*Filled*` row and its `*Outlined*` twin now resolve to the SAME glyph, so any control that
 *     switches between the pair to show state loses that signal under the flag. Every such control
 *     has another one: the bar buttons carry a subtle fill, and the sidebar's active nav item takes a
 *     blue background and blue text (`NavigationLinkItem.styled`). `iconActive` is a no-op for
 *     `GroupsFilledIcon` and `SettingsFilledIcon` as a result;
 *   - the LEGACY path is untouched. `createSvgIcon` only consults this table when
 *     `useInheritedVisualRefresh()` is true, and with the flag off a `*Filled*` export renders its
 *     own local SVG — which is why the per-call-site guards (`handRaised && !VISUAL_REFRESH`) still
 *     have to stay.
 */
export const ICON_SWAPS = {
  // ─── Local SVGs ────────────────────────────────────────────────────────────────────────────────
  AddIcon: swapTo(PhPlus),
  ArrowRightIcon: swapTo(PhArrowRight),
  ArrowUpIcon: swapTo(PhArrowUp),
  AutoRenewIcon: swapTo(PhArrowsClockwise),
  BarChartIcon: swapTo(PhChartBar),
  BookSparkIcon: none(
    'A book with a sparkle. Phosphor has both parts but no composite, and assembling one is a new glyph, not a match.'
  ),
  BorderColorIcon: ask(
    'PencilLine',
    'Material `border_color` is a pen over a filled colour swatch; `PencilLine`s line is a rule, so the "colour" half is lost.'
  ),
  CalendarIcon: swapTo(PhCalendar),
  CancelPresentationFilledIcon: ask(
    'ProjectorScreen',
    'Nothing in Phosphor is a screen with an ✗ — `MonitorX` does not exist. The cancel half would have to be dropped.'
  ),
  ChartSelectIcon: none('A bar chart inside a marquee selection. No Phosphor glyph combines a chart with a selection.'),
  ChatIcon: swapTo(PhChatsCircle),
  CheckFilledIcon: swapTo(PhCheckCircle),
  CheckIcon: swapTo(PhCheck),
  ChevronDownIcon: swapTo(PhCaretDown),
  ChevronLeftIcon: swapTo(PhCaretLeft),
  ChevronRightIcon: swapTo(PhCaretRight),
  ChevronUpIcon: swapTo(PhCaretUp),
  CloseIcon: swapTo(PhX),
  CopyIcon: swapTo(PhCopy),
  DeleteIcon: swapTo(PhTrash),
  DoubleArrowLeftIcon: swapTo(PhCaretDoubleLeft),
  DownloadIcon: swapTo(PhDownloadSimple),
  DragIndicatorIcon: swapTo(PhDotsSixVertical),
  DuplicateIcon: ask('CopySimple', COLLAPSES_ONTO('CopyIcon', 'one two-sheet copy glyph')),
  EditIcon: swapTo(PhPencilSimple),
  EmojiFilledIcon: swapTo(PhSmiley),
  EmojiOutlinedIcon: swapTo(PhSmiley),
  ErrorFilledIcon: swapTo(PhWarningCircle),
  ErrorOutlinedIcon: swapTo(PhWarningCircle),
  ExitToAppIcon: swapTo(PhSignOut),
  FileTextIcon: swapTo(PhFileText),
  FilterIcon: swapTo(PhFunnelSimple),
  ForumIcon: swapTo(PhChats),
  FramePersonIcon: ask(
    'UserFocus',
    'Material `frame_person` is a person inside a video frame; `UserFocus` is a person inside focus brackets — a camera-framing cue rather than a video one.'
  ),
  FramePersonOffIcon: none(
    'Phosphor has no slashed variant of any person-in-frame glyph, and the "off" state is the whole meaning.'
  ),
  GoogleColouredIcon: none(
    'Four-colour brand mark. Phosphor logo icons are monochrome, and substituting one on a Google sign-in button breaks Googles own brand guidance.'
  ),
  GroupOutlinedIcon: swapTo(PhUsers),
  /**
   * `HandPalm`, not `Hand`: design asked for the open palm on the raise-hand control (HNS-366).
   * Phosphor's `Hand` is a waving hand, which reads as a greeting rather than as "I'd like to speak".
   *
   * Re-mapped rather than given a new export because all three call sites already mean the same
   * thing and have to agree — the bar trigger, its More-menu row, and the hand-raised indicator in
   * the participants list. `BackHandOutlinedIcon` stays on `Hand` below: it is the Privacy &
   * security tile in `settingsPathIcons`, a "stop" hand rather than a raised one.
   */
  HandFilledIcon: swapTo(PhHandPalm),
  HandOutlinedIcon: swapTo(PhHandPalm),
  HelpOutlinedIcon: swapTo(PhQuestion),
  HomeOutlinedIcon: swapTo(PhHouse),
  ImageIcon: swapTo(PhImage),
  InfoFilledIcon: swapTo(PhInfo),
  InfoOutlinedIcon: swapTo(PhInfo),
  InsightsIcon: swapTo(PhChartLineUp),
  LinkIcon: swapTo(PhLink),
  LockIcon: swapTo(PhLock),
  LoginIcon: swapTo(PhSignIn),
  LogoutIcon: swapTo(PhSignOut),
  MenuIcon: swapTo(PhList),
  MicrophoneOffFilledIcon: swapTo(PhMicrophoneSlash),
  MicrophoneOffOutlinedIcon: swapTo(PhMicrophoneSlash),
  MicrophoneOnIcon: swapTo(PhMicrophone),
  MoreHorizontalIcon: swapTo(PhDotsThree),
  MoreVerticalIcon: swapTo(PhDotsThreeVertical),
  OutlookColouredIcon: none('Multi-colour brand mark; see GoogleColouredIcon.'),
  ParticipantsIcon: ask('UsersThree', COLLAPSES_ONTO('GroupsOutlinedIcon', 'one three-person glyph')),
  PersonOutlinedIcon: swapTo(PhUser),
  PhoneFilledIcon: swapTo(PhPhone),
  PinIcon: swapTo(PhPushPin),
  PlayCircleIcon: swapTo(PhPlayCircle),
  PowerSettingsIcon: swapTo(PhPower),
  /**
   * Resolved from `ask` to a swap on HNS-366: design chose `MonitorArrowUp` for the Present control.
   *
   * The collapse the `ask` warned about is accepted rather than gone — `ScreenShareIcon` below still
   * wants the same glyph and stays an `ask`, so the two are no longer at risk of looking identical.
   * The visible consequence is inside the Present MENU, where this trigger is now outlined while the
   * "Share screen" row is still the local filled `ShareScreenIcon`. Raised with design rather than
   * guessed at here.
   */
  PresentToAllIcon: swapTo(PhMonitorArrowUp),
  RadioButtonCheckedIcon: swapTo(PhRadioButton),
  /** The legacy SVG is a full-colour raster; same single-colour palm as `HandOutlinedIcon` above. */
  RaisedHandIcon: swapTo(PhHandPalm),
  RecordVoiceOverIcon: ask(
    'UserSound',
    'Material `record_voice_over` is a head with sound arcs at the mouth; `UserSound` puts the waves beside the head, so the "speaking" read is weaker.'
  ),
  /**
   * The reactions control on the live-event bar, which design draws as confetti under the refresh
   * (HNS-366, Figma 838:23914).
   *
   * Its own export rather than a re-map of `EmojiOutlinedIcon`, even though both render the same
   * legacy SVG: that glyph is ALSO the chat's "Add reaction" control, which opens an emoji picker,
   * and confetti on a "pick an emoji" button is the wrong idea. Named for the ROLE rather than the
   * glyph precisely because the two design systems draw this control differently — there is no one
   * name that describes both a smiley and a party popper.
   */
  ReactionsIcon: swapTo(PhConfetti),
  ReplayIcon: swapTo(PhArrowCounterClockwise),
  RestartIcon: swapTo(PhArrowClockwise),
  ScreenShareIcon: ask(
    'MonitorArrowUp',
    COLLAPSES_ONTO('PresentToAllIcon and ShareScreenIcon', 'one monitor-with-arrow glyph')
  ),
  SearchIcon: swapTo(PhMagnifyingGlass),
  SendIcon: swapTo(PhPaperPlaneTilt),
  SettingsAccountIcon: swapTo(PhUserGear),
  SettingsFilledIcon: swapTo(PhGear),
  SettingsIcon: swapTo(PhGear),
  ShareIcon: swapTo(PhShareNetwork),
  ShareScreenIcon: none(
    'A monitor with a DOWNWARD arrow, and it has to stay distinct from ScreenShare. Phosphor has no such pair.'
  ),
  SpeakerIcon: swapTo(PhSpeakerHigh),
  StarIcon: swapTo(PhStar),
  TriangleArrowDownIcon: ask(
    'CaretDown (fill)',
    'A solid equilateral triangle. `CaretDown` at fill weight is a chevron-derived wedge, noticeably narrower.'
  ),
  TriangleArrowUpIcon: ask('CaretUp (fill)', 'See TriangleArrowDownIcon.'),
  UploadIcon: swapTo(PhUploadSimple),
  VideocamIcon: swapTo(PhVideoCamera),
  VideocamOffIcon: swapTo(PhVideoCameraSlash),
  VideocamOutlinedIcon: swapTo(PhVideoCamera),
  VisibilityLockIcon: none('An eye with a padlock (21x17). No Phosphor composite, and both halves carry meaning.'),
  VisibilityOffIcon: swapTo(PhEyeSlash),
  VisibilityOnIcon: swapTo(PhEye),
  VoiceOverOffIcon: none(
    'A head with sound arcs and a slash. Phosphor has no slashed person-voice glyph, and the slash is the meaning.'
  ),
  WarningFilledIcon: swapTo(PhWarning),
  WarningOutlinedIcon: swapTo(PhWarning),
  WifiBadIcon: swapTo(PhWifiLow),
  WifiMediumIcon: swapTo(PhWifiMedium),
  WifiOkIcon: swapTo(PhWifiHigh),

  // ─── @mui/icons-material re-exports ────────────────────────────────────────────────────────────
  AccountCircleIcon: swapTo(PhUserCircle),
  ArticleOutlinedIcon: swapTo(PhArticle),
  AssignmentIcon: swapTo(PhClipboardText),
  AssignmentOutlinedIcon: swapTo(PhClipboardText),
  // Decided in review rather than deferred: the only place this renders is Natalie's sidebar entry,
  // where the label already says "Natalie", so the speech bubble Material draws around the sparkles
  // is redundant. `Sparkle` alone is the intent.
  AssistantIcon: swapTo(PhSparkle),
  AvTimerIcon: swapTo(PhTimer),
  BackHandOutlinedIcon: swapTo(PhHand),
  BarChartRoundedIcon: swapTo(PhChartBar),
  CalendarMonthIcon: swapTo(PhCalendarDots),
  CalendarMonthOutlinedIcon: swapTo(PhCalendarDots),
  CellTowerIcon: swapTo(PhCellTower),
  ChatBubbleOutlineIcon: swapTo(PhChatCircle),
  CheckBoxOutlinedIcon: swapTo(PhCheckSquare),
  ClosedCaptionsIcon: swapTo(PhClosedCaptioning),
  ClosedCaptionsOutlinedIcon: ask(
    'SubtitlesSlash',
    'The source is `ClosedCaptionOffOutlined` — captions OFF. `ClosedCaptioningSlash` does not exist, and `SubtitlesSlash` is a different frame shape from its non-slashed sibling, so the pair would not match.'
  ),
  CommitIcon: swapTo(PhGitCommit),
  ConstructionIcon: ask(
    'Wrench',
    'Material `construction` is a crossed wrench and screwdriver. `Wrench` alone reads as a single tool — fine for "settings", weaker for "under construction".'
  ),
  EventIcon: ask(
    'CalendarCheck',
    'Material `event` is a calendar with a filled day marker, not a tick. `CalendarCheck` asserts completion, which changes the meaning.'
  ),
  FormatListNumberedIcon: swapTo(PhListNumbers),
  ForumOutlinedIcon: swapTo(PhChats),
  FullscreenOutlinedIcon: swapTo(PhCornersOut),
  Groups2OutlinedIcon: swapTo(PhUsersThree),
  GroupsFilledIcon: swapTo(PhUsersThree),
  GroupsOutlinedIcon: swapTo(PhUsersThree),
  HeadphonesIcon: swapTo(PhHeadphones),
  HearingIcon: swapTo(PhEar),
  HubOutlinedIcon: ask(
    'Graph',
    'Material `hub` is a hub-and-spoke with a filled centre; `Graph` is a general node graph with no centre, which is the part that means "hub".'
  ),
  InsertEmoticonOutlinedIcon: swapTo(PhSmiley),
  LabelOutlinedIcon: swapTo(PhTag),
  LanguageIcon: swapTo(PhGlobe),
  LogoutOutlinedIcon: swapTo(PhSignOut),
  ManageAccountsOutlinedIcon: swapTo(PhUserGear),
  PauseIcon: swapTo(PhPause),
  PauseOutlinedIcon: swapTo(PhPause),
  PeopleAltOutlinedIcon: swapTo(PhUsers),
  PersonAddAlt1OutlinedIcon: swapTo(PhUserPlus),
  PersonAddAltOutlinedIcon: swapTo(PhUserPlus),
  PersonOffOutlinedIcon: none(
    'A person with a slash. `UserMinus` is removal and `UserCircleDashed` is absence — neither is "off". Phosphor has no slashed person.'
  ),
  /* `fill` kept: an outlined triangle is a different symbol, not a lighter one. See the weight note. */
  PlayArrowIcon: swapTo(PhPlay, 'fill'),
  PlayArrowOutlinedIcon: swapTo(PhPlay),
  QueryStatsOutlinedIcon: none(
    'A line chart inside a magnifier. `MagnifyingGlassChart` does not exist and no Phosphor glyph combines the two.'
  ),
  QuestionAnswerOutlinedIcon: ask(
    'ChatCenteredDots',
    COLLAPSES_ONTO('ForumOutlinedIcon', 'overlapping-bubble glyphs that do not distinguish question from answer')
  ),
  RocketOutlinedIcon: swapTo(PhRocket),
  SettingsInputAntennaIcon: ask('Broadcast', COLLAPSES_ONTO('CellTowerIcon', 'radiating-antenna glyphs')),
  SettingsOutlinedIcon: swapTo(PhGear),
  SpeedIcon: swapTo(PhSpeedometer),
  /* `fill` kept, as `PlayArrowIcon`: an outlined square reads as a frame, not a stop. */
  StopIcon: swapTo(PhStop, 'fill'),
  SupportOutlinedIcon: swapTo(PhLifebuoy),
  TagOutlinedIcon: swapTo(PhHash),
  TimelineOutlinedIcon: none(
    'A zigzag line with nodes at each vertex. `ChartLine` has no nodes and `Path`/`Signpost` mean something else.'
  ),
  UnpublishedOutlinedIcon: none(
    'A check-circle with a slash through it. Phosphor has neither that composite nor a slashed check.'
  ),
  VerifiedOutlinedIcon: swapTo(PhSealCheck),
  VolumeDownIcon: swapTo(PhSpeakerLow),
  VolumeUpIcon: swapTo(PhSpeakerHigh),
  WifiIcon: swapTo(PhWifiHigh),

  // ─── Folded in from files that imported @mui/icons-material directly ───
  AppsOutlinedIcon: ask(
    'SquaresFour',
    'Material `apps` is a 3x3 dot grid; `SquaresFour` is a 2x2 of rounded squares. It also renders inside an OS-chrome tile that impersonates the macOS Settings row, so design should confirm before it moves.'
  ),
  LanguageOutlinedIcon: swapTo(PhGlobe),
  LockOutlinedIcon: swapTo(PhLock),
  MenuOutlinedIcon: swapTo(PhList),
  CloudOffIcon: swapTo(PhCloudSlash),
  DevicesOtherIcon: swapTo(PhDevices),
  ErrorOutlineIcon: swapTo(PhWarningCircle),
  GppBadIcon: swapTo(PhShieldWarning),
  HourglassEmptyIcon: swapTo(PhHourglassSimple),
  MicNoneIcon: swapTo(PhMicrophone),
  OpenInNewIcon: swapTo(PhArrowSquareOut),
  VolumeOffIcon: swapTo(PhSpeakerSlash),
  WebAssetOffIcon: none(
    'A browser window with a slash. `BrowserX` does not exist in Phosphor and nothing else expresses "this browser cannot".'
  ),
  PriorityHighIcon: swapTo(PhExclamationMark),
  EmailOutlinedIcon: swapTo(PhEnvelope),
  InsightsOutlinedIcon: swapTo(PhChartLineUp),
  InterpreterModeOutlinedIcon: ask(
    'UserSound',
    'Material `interpreter_mode` is a head with a speech bubble at the mouth; `UserSound` puts waves beside the head, weakening the "interpreting" read.'
  ),
  InterpreterModeIcon: ask('UserSound', 'See InterpreterModeOutlinedIcon.'),
  SentimentVerySatisfiedOutlinedIcon: ask(
    'SmileyWink',
    'Material `sentiment_very_satisfied` has arched "^^" eyes that read as delight. `Smiley` is neutral-happy and `SmileyWink` closes one eye, so neither is the same step on the scale.'
  ),
  ArrowDownwardOutlinedIcon: swapTo(PhArrowDown),
  ScienceOutlinedIcon: swapTo(PhFlask),
  RefreshIcon: swapTo(PhArrowClockwise),
  KeyboardOutlinedIcon: swapTo(PhKeyboard),
  NotesIcon: ask(
    'Notepad',
    'Material `notes` is four bare text rules with no container; `Notepad` and `Note` both draw a page around them.'
  ),
  GraphicEqIcon: swapTo(PhWaveform),
  SendOutlinedIcon: swapTo(PhPaperPlaneTilt),
  MicIcon: swapTo(PhMicrophone),
  ArrowDownwardIcon: swapTo(PhArrowDown),
  ArrowUpwardIcon: swapTo(PhArrowUp),
  RemoveIcon: swapTo(PhMinus),
  ArrowDropDownIcon: ask(
    'CaretDown (fill)',
    'Material `arrow_drop_down` is a solid triangle; `CaretDown` at fill weight is a narrower chevron-derived wedge. Same question as TriangleArrowDownIcon.'
  ),
  FormatBoldIcon: swapTo(PhTextB),
  FormatItalicIcon: swapTo(PhTextItalic),
  FormatListBulletedIcon: swapTo(PhListBullets),
  FormatUnderlinedIcon: swapTo(PhTextUnderline),
  ContentCopyIcon: swapTo(PhCopy),
  ThumbUpOutlinedIcon: swapTo(PhThumbsUp),
  ThumbDownOutlinedIcon: swapTo(PhThumbsDown),
  ArrowBackIcon: swapTo(PhArrowLeft),
  ArrowForwardIcon: swapTo(PhArrowRight),
  AddOutlinedIcon: swapTo(PhPlus),
  BrokenImageOutlinedIcon: swapTo(PhImageBroken),
  CloseOutlinedIcon: swapTo(PhX),
  BlockOutlinedIcon: swapTo(PhProhibit),
  BlurOnOutlinedIcon: none(
    'A grid of dots of varying size standing in for blur. Phosphor has `Drop`/`Circle` but nothing that reads as blur.'
  ),
  MaterialCloseIcon: swapTo(PhX),
  MaterialChevronLeftIcon: swapTo(PhCaretLeft),
  MaterialChevronRightIcon: swapTo(PhCaretRight),
  MaterialExitToAppIcon: swapTo(PhSignOut),
  MaterialMicOffIcon: swapTo(PhMicrophoneSlash),
  MaterialVideocamOffIcon: swapTo(PhVideoCameraSlash),
  MaterialBarChartIcon: swapTo(PhChartBar),
  MaterialChatIcon: swapTo(PhChatCircle),
  MaterialRecordVoiceOverIcon: ask('UserSound', 'See RecordVoiceOverIcon — the local SVG has the same question.'),

  // ─── Glyphs MUI injects as its own defaults, wrapped so the refresh can reach them ───
  CheckBoxOutlineBlankIcon: swapTo(PhSquare),
  /* `fill` kept on both: these are Material's CHECKED marks, and an outlined one reads as unchecked. */
  CheckBoxIcon: swapTo(PhCheckSquare, 'fill'),
  IndeterminateCheckBoxIcon: swapTo(PhMinusSquare, 'fill'),
  FirstPageIcon: swapTo(PhCaretLineLeft),
  LastPageIcon: swapTo(PhCaretLineRight),

  // ─── Feature-local barrels ───
  // Registered here rather than annotated inline (as the other feature-local barrels are) so the
  // gallery story picks it up — an icon design has opinions about needs to be visible to design.
  //
  // NOTE: `UserSound` is also the named candidate on four open `ask` rows (`RecordVoiceOver*`,
  // `InterpreterMode*`). If those resolve to it too, five distinct ideas collapse onto one glyph —
  // worth settling at the sync, per the collision rule.
  NattersIcon: swapTo(PhUserSound),
} as const satisfies Record<string, IconSwapEntry>;

export type IconExportName = keyof typeof ICON_SWAPS;

/**
 * The barrel's accessor. Keyed by EXPORT name rather than the factory's `displayName`, because the
 * two differ (`PowerSettingsIcon` is built as `Power`) and the export name is what a reader of the
 * gallery, a call site or a code review is actually looking at.
 *
 * Typed against the table's keys, so a typo is a compile error rather than a silently unswapped icon
 * — which is the failure this indirection is here to prevent.
 */
export const swap = (name: IconExportName): PhosphorSwap => ICON_SWAPS[name].swap;
